import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="password-strength-meter"
export default class extends Controller {
  connect() {
  }

  getScore(event) {
    const password = event.target.value;
    const pwsmDisplay = document.querySelector('#password-strength-meter-display');

    if (password.length < 3) {
      pwsmDisplay.className = '';
      pwsmDisplay.querySelector('.label').innerHTML = '';
      return;
    }

    const strengthDescriptions = { 0: 'Very Weak', 1: 'Weak', 2: 'Medium', 3: 'Strong', 4: 'Very Strong' }

    let score = 100;
    let strength = 0;
    const lowerCase = password.match(/[a-z]/g);
    const upperCase = password.match(/[A-Z]/g);
    const digits = password.match(/\d/g);
    const nonAlpha = password.match(/\W/g);
    const spaces = password.match(/\s/g);

    if (password.length < 16) score -= 10;
    if (password.length < 12) score -= 40;
    if (password.length < 8) score -= 20;
    if ((upperCase && !lowerCase) || (!upperCase && lowerCase)) score -=40;
    if (!digits) score -= 20;
    if (!nonAlpha) score -= 20;
    if (!spaces) score -= 20;
    if (!digits && !nonAlpha && !spaces) score -= 15;

    if (score < 20) strength = 0;
    else if (score < 40) strength = 1;
    else if (score < 60) strength = 2;
    else if (score < 92) strength = 3;
    else strength = 4;

    pwsmDisplay.className = 'pwsm-' + strength;
    pwsmDisplay.querySelector('.label').innerHTML = strengthDescriptions[strength];
  }

  repeatedCharacters(str) {
    const repeatedChars = new Set();
    for (let i = 0; i < str.length; i++) {
      const char = str[i];
      if (str.indexOf(char) !== i && str.lastIndexOf(char) === i) {
	repeatedChars.add(char);
      } else if (str.indexOf(char) !== str.lastIndexOf(char)) {
	repeatedChars.add(char);
      }
    }
    return repeatedChars.size > 0;
  }
}
